<template>
  <div
      v-tooltip="showTooltip && disabled && {content: errorMessage, trigger: 'hover', placement: 'bottom', offset: 0}">
    <button :disabled="disabled" class="btn btn-danger" title="Delete" v-tooltip="'Delete domain'"
            @click="onDeleteButtonClick($event)">
      <i class="fas fa-fw fa-trash"></i>
    </button>
    <delete-email-domain-modal
        :domain="domain"
        :shown="modalShown"
        @close-modal="onCloseModal"
    ></delete-email-domain-modal>
  </div>
</template>

<script>
import DeleteEmailDomainModal from './DeleteEmailDomainModal';
import {showProfileLockedWarning} from '../../../utility/showProfileLockedWarning';
import {VTooltip} from 'v-tooltip'

export default {
  name: 'delete-email-domain-button',
  components: {DeleteEmailDomainModal},
  props: {
    domain: {
      type: Object,
      required: true,
    },
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
    disabled: Boolean,
    showTooltip: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      modalShown: false,
      errorMessage: this.profileLocked ? 'Your profile is locked' : 'This domain has been created in the past 5 minutes',
    };
  },
  methods: {
    onDeleteButtonClick(event) {
      showProfileLockedWarning.warning(this.profileLocked).then(() => {
        event.stopPropagation();
        this.modalShown = true;
      });
    },
    onCloseModal() {
      this.modalShown = false;
    },
  },
};
</script>
